import React from "react";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { ImagePager } from "../components/common/ImagePager";

export default function PracticePage() {
  const practiceImages = [
    {
      src: "/images/start_image_1.jpeg",
      alt: "Praxisraum mit Therapieliege",
    },
    {
      src: "/images/start_image_6.jpg",
      alt: "Besprechungsraum",
    },
    {
      src: "/images/start_image_3.jpeg",
      alt: "Therapieraum mit Sprossenwand",
    },
  ];

  return (
    <>
      <SEOHelmet page="praxis" />

      <main className="space-y-12 sm:space-y-24">
        <section className="overflow-hidden pt-6" aria-label="Unsere Praxis">
          <div className="mx-auto px-6 lg:px-8">
            <header className="mb-10 sm:mb-14">
              <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-gray-900 dark:text-white drop-shadow-sm">
                Unsere Praxis
              </h1>
            </header>

            <div className="grid gap-6 sm:gap-8 lg:grid-cols-2">
              <div>
                <p className="mt-2 text-lg leading-7 text-gray-600 dark:text-gray-300 lg:pr-8">
                  Unsere Praxis ist ein Ort der Ruhe und Konzentration, gestaltet für Ihre individuellen Therapiebedürfnisse.
                  Der großzügige, reizarm gestaltete Therapieraum mit Sprossenwand und professioneller Therapieliege bietet den
                  perfekten Rahmen für therapeutische Übungen.
                </p>
                <p className="mt-4 text-lg leading-7 text-gray-600 dark:text-gray-300 lg:pr-8">
                  In unserem gemütlich eingerichteten Besprechungsraum schaffen wir eine vertrauensvolle Atmosphäre für persönliche
                  Gespräche und Beratungen.
                </p>
                <p className="mt-4 text-lg leading-7 text-gray-600 dark:text-gray-300 lg:pr-8">
                  Modernste Therapiematerialien und bewährte Konzepte ermöglichen es uns, Ihre Therapie optimal auf Ihre persönlichen
                  Bedürfnisse abzustimmen.
                </p>
              </div>

              <ImagePager images={practiceImages} />
            </div>
          </div>
        </section>
      </main>
    </>
  );
}


